import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import Form from 'component/organism/workflow/forms/form/Form';
import { FormikProvider, useFormik } from 'formik';
import { isEqual } from 'lodash';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  formId: Yup.string().required('Required'),
  // formName: Yup.string().required('Form Name is required'),
  // formTitle: Yup.string().required('Form Title is required'),
  // button: Yup.string().required('Button label is required'),
  // inputs: Yup.array()
  //   .of(
  //     Yup.object().shape({
  //       inputLabel: Yup.string().required('Input Label is required'),
  //       inputPlaceholder: Yup.string().required(
  //         'Input Placeholder is required'
  //       ),
  //       inputType: Yup.string().required('Input Type is required'),
  //       mandatory: Yup.boolean(),
  //     })
  //   )
  //   .min(1, 'At least one input field is required'),
});

const FormModal = ({ isOpen, onClose, title, id, isError }) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    initialWorkflowData,
    setIsChanged,
  } = useWorkflowContext();

  const formik = useFormik({
    initialValues: {
      formId: selectedNode?.form?.formId || '',
      // formName: '',
      // formTitle: '',
      // button: '',
      // inputs: [
      //   {
      //     inputLabel: '',
      //     inputPlaceholder: '',
      //     inputType: '',
      //     mandatory: false,
      //   },
      // ],
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const initialNode = initialWorkflowData?.find((node) => node?.id === id);
      if (initialNode) {
        const { formId } = initialNode?.form || {};
        const initialMessageObject = {
          formId,
        };
        const currentValues = formik.values;
        const changed = !isEqual(currentValues, initialMessageObject);
        setIsChanged((prev) => {
          const alreadyExists = prev?.includes(id);
          if (changed && !alreadyExists) {
            return [...prev, id];
          }
          if (!changed && alreadyExists) {
            return prev?.filter((nodeId) => nodeId !== id);
          }

          return prev;
        });
      }
      setSubmitting(false);
    },
  });

  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? {
                ...node,
                form: {
                  ...formik.values,
                },
                is_Error: isError,
              }
            : node
        );
        setWorkflowData((prev) => ({
          ...prev,
          nodes: updatedNodes,
        }));

        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );

    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);
  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <Form isOpen={isOpen} />
      </FormikProvider>
    </RightSlider>
  );
};

export default FormModal;
